export default (props) => (
  /**
   * Ícone "x" com cor parametrizada
   * Usado geralmente para fechar abas.
   */
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line
      x1="10.3391"
      y1="1.53921"
      x2="1.89422"
      y2="9.98411"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="1"
      y1="-1"
      x2="12.9429"
      y2="-1"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.89868 0.125)"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
